// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GrantsMarketingButton-cls1__b199192ed2c7417f8e54{/*!*/}.GrantsMarketingButton-cls2___c2f61d9123e38055e7b{}@media(max-width: 417px),(min-width: 769px)and (max-width: 991px){.GrantsMarketingButton-cls2___c2f61d9123e38055e7b{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "GrantsMarketingButton-cls1__b199192ed2c7417f8e54",
	"cls2": "GrantsMarketingButton-cls2___c2f61d9123e38055e7b GrantsMarketingButton-cls1__b199192ed2c7417f8e54"
};
export default ___CSS_LOADER_EXPORT___;
